import React from 'react'

const MultiLocationIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 30 30"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <g
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                        <path
                            d="M25.922 22.287 28.461 28H1.539l2.55-5.738a20.926 20.926 0 0 0-.562-1.197L0 29h30l-3.518-7.916c-.202.405-.392.808-.56 1.203z"
                            fill="#e37f26"
                            opacity={1}
                            data-original="#000000"
                            className=""
                        />
                        <path
                            d="M6 15.25a2.5 2.5 0 0 1-2.5-2.5c0-1.304 1-2.361 2.273-2.477A9.53 9.53 0 0 1 5.5 8.022c0-.075.01-.148.012-.224C2.983 8.048 1 10.162 1 12.763c0 .826.2 1.604.553 2.29 1.052 2.689 3.575 6.038 4.148 8.946h.624c.4-2.031 1.734-4.273 2.864-6.36a94.82 94.82 0 0 1-1.594-2.979c-.433.363-.985.59-1.595.59zM24.488 7.799c.002.076.012.148.012.224 0 .759-.095 1.515-.273 2.251a2.49 2.49 0 0 1 2.273 2.477 2.5 2.5 0 0 1-2.5 2.5 2.48 2.48 0 0 1-1.594-.589 92.173 92.173 0 0 1-1.586 2.985c1.137 2.085 2.48 4.324 2.881 6.354h.624c.573-2.908 3.069-6.257 4.122-8.946A5 5 0 0 0 29 12.764c0-2.601-1.982-4.715-4.512-4.965z"
                            opacity={1}
                            fill="#4bad48"
                            data-original="#00000050"
                            className=""
                        />
                        <path
                            d="M9.045 20c-.18.334-.355.668-.521 1h2.479c-.17-.332-.344-.666-.521-1zM21.495 21a48.336 48.336 0 0 0-.526-1h-1.426c-.176.334-.349.668-.518 1zM15 0c-4.419 0-8 3.592-8 8.022 0 1.32.32 2.565.883 3.663 1.685 4.304 5.722 9.662 6.64 14.314h.997c.918-4.652 4.912-10.011 6.596-14.314a7.995 7.995 0 0 0 .885-3.663C23 3.592 19.418 0 15 0zm0 12c-2.21 0-4-1.79-4-4s1.79-4 4-4a4 4 0 1 1 0 8z"
                            fill="#e37f26"
                            opacity={1}
                            data-original="#000000"
                            className=""
                        />
                    </g>
                </g>
            </svg>

        </>
    )
}

export default MultiLocationIcon